import React from 'react';
import { RitualAchievements } from './rituals/RitualAchievements';
export const AchievementsSection: React.FC = () => {
  return <RitualAchievements data-id="element-160" />;
};